import React, { useContext } from "react";
import * as styles from "./SignsOverlayButton.module.scss";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import { SignsOverlayContext } from "@app/components/SignsOverlayContext/SignsOverlayContext";
import Icon from "@app/components/Icon";
//import PropTypes from 'prop-types'

const useShowButton = () => {
	const { pathname } = useLocation();
	const { signsOverlayHandler } = useContext(SignsOverlayContext);
	if (
		signsOverlayHandler?.enabled &&
		!pathname.match(/\/inspection\/.+\/summary/) &&
		!pathname.match(/\/inspection\/.+\/confirmation/)
	) {
		return {
			handler: signsOverlayHandler.onClick,
		};
	}
	return false;
};

const SignsOverlayButton = () => {
	const SignsOverlayButtonClassName = classNames({
		[styles["signs-overlay-button"]]: true,
	});
	const showButton = useShowButton();

	return !showButton ? null : (
		<button className={SignsOverlayButtonClassName} onClick={showButton?.handler}>
			<Icon icon={"arrow-left"} size={24} className={styles["signs-icon"]} className={styles["icon"]} />
		</button>
	);
};

SignsOverlayButton.propTypes = {};

export default SignsOverlayButton;
